import { createSlice } from "@reduxjs/toolkit";
import {
  clearTechniqueFeedbackValues,
  closeAIFeedbackToast,
  openAIFeedbackToast,
  setTechniqueFeedbackValue,
  setAIToastStep,
  getTechniquesByAISearch,
} from "domain/ai-search/ai-search.actions";
import { Feedback } from "domain/entities/ai-search.entities";

export type ToastStep = "first" | "positive" | "negative" | "thanks";

export type AISearchState = {
  isAIFeedbackToastOpen: boolean;
  isAIFeedbackLoading: boolean;
  techniqueAISearchResults: string[];
  techniqueFeedback: Feedback;
  toastStep: ToastStep;
  isAISearchLoading: boolean;
};

const initialState: AISearchState = {
  isAIFeedbackToastOpen: false,
  isAIFeedbackLoading: false,
  techniqueAISearchResults: [],
  techniqueFeedback: {},
  toastStep: "first",
  isAISearchLoading: false,
};

export const aiSearchSlice = createSlice({
  name: "aiSearch",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //OPEN AI FEEDBACK TOAST
    builder.addCase(openAIFeedbackToast.fulfilled, (state, action) => {
      state.isAIFeedbackToastOpen = true;
    });
    //CLOSE AI FEEDBACK TOAST
    builder.addCase(closeAIFeedbackToast.fulfilled, (state, action) => {
      state.isAIFeedbackToastOpen = false;
    });
    //SET TECHNIQUE FEEDBACK VALUE
    builder.addCase(setTechniqueFeedbackValue.fulfilled, (state, action) => {
      state.techniqueFeedback = {
        ...state.techniqueFeedback,
        ...action.payload,
      };
    });
    //CLEAR TECHNIQUE FEEDBACK VALUES
    builder.addCase(clearTechniqueFeedbackValues.fulfilled, (state, action) => {
      state.techniqueFeedback = {};
      state.techniqueAISearchResults = [];
    });
    //UPDATE TOAST STEP
    builder.addCase(setAIToastStep.fulfilled, (state, action) => {
      state.toastStep = action.payload.step;
    });
    //GET TECHNIQUES BY AI SEARCH
    builder.addCase(getTechniquesByAISearch.fulfilled, (state, action) => {
      state.techniqueAISearchResults = action.payload.techniqueHits
        .filter((hit) => hit.score > 0.015)
        .map((hit) => hit.innizRef);
      state.isAISearchLoading = false;
    });
    builder.addCase(getTechniquesByAISearch.pending, (state, action) => {
      state.isAISearchLoading = true;
    });
  },
});
